import RequestNoToken from './RequestNoToken'
// 本地测试环境 http://172.17.53.13:9900,
// UAT环境 https://dpex-api-uat.ipfx.net
let baseUrl = 'https://dpex-api-uat.ipfx.net'
// 线上域名
if (location.host === 'space.ipfx.net') {
  baseUrl = 'https://dp-api.ipfx.net'
}
if (location.host === '192.168.3.69:11006') {
  baseUrl = 'http://192.168.3.158:9900'
}
const axios = new RequestNoToken(baseUrl)

export default axios